<div class="warp-question">
  <div class="contact">
    <que-contact-circle [user]="recipient?.user"></que-contact-circle>
    {{ recipient?.user?.firstName }} {{ recipient?.user?.lastName }}
  </div>
  <div class="header" [ngClass]="{'compare':showComparison$()}">
    <div class="item first"></div>
    <div class="item" *ngFor="let q of questionData?.question?.modularQuestions">
      {{ q.title == undefined || q.title == "" ? "no title" : q.title }}
    </div>
  </div>
  <div class="warp-compare">
    <p *ngIf="showComparison$()" class="tag" translate>data.current</p>
    <div class="table">
      <que-answer-row-to-group *ngFor="let order of [].constructor(rows$()); let i = index" [order]="i + 1"
        [answers]="answers" [modularQuestions]="questionData?.question?.modularQuestions"></que-answer-row-to-group>
    </div>
  </div>
  <div *ngIf="showComparison$()" class="second-header compare">
  </div>
  <div class="warp-compare" *ngIf="showComparison$()&&rowsSource$()>0">
    <p class="tag" translate>data.previous</p>
    <div class="table">
      <que-answer-row-to-group *ngFor="let order of [].constructor(rowsSource$()); let i = index" [order]="i + 1"
        [answers]="answersSource"
        [modularQuestions]="questionData?.questionSource?.modularQuestions"></que-answer-row-to-group>
    </div>
  </div>
</div>